import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalContent,
  Text,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'

interface Props {
  paymentName: string
  onClose: () => void
}

export const OfflinePayment = ({ paymentName, onClose }: Props) => {
  return (
    <Modal onClose={onClose}>
      <ModalHeader>Offline Payment</ModalHeader>
      <ModalContent>
        <Text tag="p">
          <T
            _str={`${paymentName} payments can not be accepted while the register is offline.`}
            paymentName={paymentName}
          />
        </Text>
      </ModalContent>
    </Modal>
  )
}
